"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkButton = exports.Button = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _withTheme = require("../../wrappers/with-theme");

var _utils = require("../utils");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  white-space: nowrap;\n  animation: ", " 5s linear;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: translateX(0%);\n    left: 100%;\n  }\n  to {\n    transform: translateX(-100%);\n    left: 0%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var scroll = (0, _styledComponents.keyframes)(_templateObject());

var ConfirmMessage = _styledComponents["default"].div(_templateObject2(), scroll);

var ConfirmButton = function ConfirmButton(_ref) {
  var onClick = _ref.onClick,
      children = _ref.children,
      confirmMessage = _ref.confirmMessage,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, ["onClick", "children", "confirmMessage", "type"]);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      canClick = _React$useState2[0],
      setCanClick = _React$useState2[1];

  var timeout = _react["default"].useRef(null);

  var confirm = _react["default"].useCallback(function (e) {
    e.preventDefault();
    setCanClick(true);
    timeout.current = setTimeout(setCanClick, 5000, false);
  }, [timeout]);

  var doOnClick = _react["default"].useCallback(function (e) {
    setCanClick(false);
    onClick && onClick(e);
  }, [onClick]);

  _react["default"].useEffect(function () {
    return function () {
      return clearTimeout(timeout.current);
    };
  }, [timeout]);

  return /*#__PURE__*/_react["default"].createElement("button", _extends({
    onClick: canClick ? type === "submit" ? null : doOnClick : confirm
  }, props, {
    type: canClick ? type : "button"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, !canClick ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute top-0 left-0 right-0 bottom-0 flex items-center overflow-hidden"
  }, /*#__PURE__*/_react["default"].createElement(ConfirmMessage, null, confirmMessage)), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: canClick ? "transparent" : null
    }
  }, children)));
};

var Button = function Button(_ref2) {
  var _ref2$buttonTheme = _ref2.buttonTheme,
      buttonTheme = _ref2$buttonTheme === void 0 ? "button" : _ref2$buttonTheme,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? "" : _ref2$className,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? "button" : _ref2$type,
      children = _ref2.children,
      large = _ref2.large,
      small = _ref2.small,
      block = _ref2.block,
      active = _ref2.active,
      showConfirm = _ref2.showConfirm,
      _ref2$confirmMessage = _ref2.confirmMessage,
      confirmMessage = _ref2$confirmMessage === void 0 ? "click to confirm" : _ref2$confirmMessage,
      props = _objectWithoutProperties(_ref2, ["buttonTheme", "className", "type", "children", "large", "small", "block", "active", "showConfirm", "confirmMessage"]);

  var theme = (0, _withTheme.useTheme)();
  buttonTheme = "".concat(buttonTheme).concat((0, _utils.composeOptions)({
    large: large,
    small: small,
    block: block,
    active: active
  }));

  if (showConfirm) {
    return /*#__PURE__*/_react["default"].createElement(ConfirmButton, _extends({
      type: type
    }, props, {
      confirmMessage: confirmMessage,
      className: "".concat(theme[buttonTheme] || theme["button"], " ").concat(className)
    }), children);
  }

  return /*#__PURE__*/_react["default"].createElement("button", _extends({
    type: type
  }, props, {
    className: "".concat(theme[buttonTheme] || theme["button"], " ").concat(className)
  }), children);
};

exports.Button = Button;

var LinkButton = function LinkButton(_ref3) {
  var _ref3$buttonTheme = _ref3.buttonTheme,
      buttonTheme = _ref3$buttonTheme === void 0 ? "button" : _ref3$buttonTheme,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? "" : _ref3$className,
      type = _ref3.type,
      children = _ref3.children,
      disabled = _ref3.disabled,
      large = _ref3.large,
      small = _ref3.small,
      block = _ref3.block,
      active = _ref3.active,
      props = _objectWithoutProperties(_ref3, ["buttonTheme", "className", "type", "children", "disabled", "large", "small", "block", "active"]);

  var theme = (0, _withTheme.useTheme)();
  buttonTheme = "".concat(buttonTheme).concat((0, _utils.composeOptions)({
    large: large,
    small: small,
    block: block,
    disabled: disabled,
    active: active
  }));
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, _extends({}, props, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    className: " ".concat(theme[buttonTheme] || theme["button"], " ").concat(className)
  }), children);
};

exports.LinkButton = LinkButton;